// extracted by mini-css-extract-plugin
export const skipToLandmarkStyles = "skipToLandmark-module--skipToLandmarkStyles--WMn_O";